import i18next from 'i18next';

const EXPIRATION_STATUS_LABELS = {
  not_specified: 'legend.notSpecified',
  up_to_date: 'legend.upToDate',
  '3_month': 'legend.expiredIn3Month',
  '1_month': 'legend.expiredInAMonth',
  '1_week': 'legend.expiredInAWeek',
  expired: 'legend.expired',
};

const translate = key => {
  if (i18next && typeof i18next.t === 'function') {
    const translated = i18next.t(key);

    if (translated !== undefined && translated !== null) {
      return translated;
    }
  }

  if (i18next && i18next.default && typeof i18next.default.t === 'function') {
    const translated = i18next.default.t(key);

    if (translated !== undefined && translated !== null) {
      return translated;
    }
  }

  return key;
};

const getExpirationStatusLabel = expirationType => {
  const labelKey = EXPIRATION_STATUS_LABELS[expirationType] || EXPIRATION_STATUS_LABELS.not_specified;

  return translate(labelKey);
};

export default getExpirationStatusLabel;
